export default __webpack_public_path__ + "static/vir-markus-edward-erica-julienne-f735b198bdbf81d7dfdc47e6a91a6166.png";